import { useState } from 'react'
import Header from '../../../../customs/Header'
import RoutePageEditor from './RoutePageEditor';
import CreateRoutePage from './CreateRoutePage';
import SettingsModal from '../Modal/settingsCustomModal';

const Main = () =>{
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);

  return (
    <section>
      <Header props={
        {
          firstName: "All",
          secondName: "Route Page Editor",
          buttonText: ""
        }} 
        handleOpen = {handleOpenCreateModal}
      />
      <RoutePageEditor/>
        <SettingsModal 
          open={openCreateModal}
          cancel={handleCloseCreateModal}
          maxWidth="480px"
          header={"Create Route Page"}
          showrightIcon={false}
          content={<CreateRoutePage handleClose={handleCloseCreateModal}/>}
        />
    </section>
  )
}

export default Main;
